// แสดงหน้าที่ clone มาจากเว็บตัวอย่าง (เนื้อหาอยู่ใน src/site/content/<key>.js)
// เนื้อหาแยกตามภาษาได้: html: { th: '...', en: '...' } — ภาษาที่ยังไม่มีจะใช้ภาษาไทย
import React, { useEffect } from 'react';
import { useLang, T } from './i18n';
import CONTENT from './content';
import './site.css';

export default function SitePage({ page }) {
  const { lang } = useLang();
  const data = CONTENT[page.key];

  // โหลด CSS เฉพาะหน้า (elementor post-xxx.css) ตอนเข้า แล้วเอาออกตอนออก
  useEffect(() => {
    if (!data) return undefined;
    if (data.title) document.title = data.title;
    const links = (data.css || []).map((href) => {
      const l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = href;
      l.setAttribute('data-site-page', page.key);
      document.head.appendChild(l);
      return l;
    });
    return () => links.forEach((l) => l.remove());
  }, [data, page.key]);

  if (!data) {
    return <div className="site-page-empty"><T k="page.notReady" /></div>;
  }
  const html = (data.html && (data.html[lang] || data.html.th)) || '';
  return (
    <div className={`site-page site-page-${page.key}`} lang={data.html && data.html[lang] ? lang : 'th'}
      dangerouslySetInnerHTML={{ __html: html }} />
  );
}
